<template>
  <chart-container :titleChart="titleChart" @onCSVDownload="handleDownloadCsv(titleChart)" @zoomEnabled="zoomGraph(true)" @zoomDisabled="zoomGraph(false)" :downloadId="downloadId" :specificSiteId="specificSiteId" :zoomGraphValue="zoomGraphValue" :downloadShow="matrix && matrix.length != 0" :isZoomEnabled="matrix && matrix.length != 0" class="bg">
    <div class="card-text-strong d-inline" slot="header">
      <div class="info-custom-tooltip ml-6">
        <i class="fa fa-info-circle"></i>
        <div class="info-custom-tooltiptext">
          <p class="mb-6">
            This chart shows the daily compliance per participant and sensor through the duration of the study. If the participant’s sensor logs data on a day, then they are considered compliant for that day. If there is no data logged, then the participant will be shown in red. Each sensor the participant has initially connected will show on this chart. If the participant has not connected a
            sensor, then the sensor brand will not appear. If they connect multiple sensors and log data across brands, then each sensor brand will be shown. “Last Logged” shows the last date that the participant logged sensor data. Hovering over a square in the chart provides additional information.
          </p>
        </div>
      </div>
    </div>
    <DailySensorComplaince :dateAndDayHeaders="dateAndDayHeaders" :height="height" v-if="matrix && matrix.length != 0" :matrixData="matrix" slot="body" @onScrollTable="onScrollTable" @statusOfDays="statusOfDays" />
    <div v-else class="align-center p-60" slot="body">
      <div class="card-text-title no-data">No Data In</div>
    </div>
  </chart-container>
</template>
<script>
import _ from "lodash";
import ChartContainer from "./chart-container.vue";
import DailySensorComplaince from "../charts/Daily-Sensor-Compliance.vue";
import * as utils from "../../services/visualization/utils";
import * as studyCompliance from "../../services/visualization/study-compliance";
import { downloadCSV } from "../../services/visualization/data-management";
import * as commonHelper from "@/components/services/common-helper";
import { mapGetters } from "vuex";

export default {
  components: {
    ChartContainer,
    DailySensorComplaince
  },

  props: {
    siteListInParticipants: [Array, []],
    zoomGraphValue: { type: String, default: "" },
    specificSiteId: { type: Array, default: null },
    titleChart: { type: String, default: "" },
    countrySelected: [Array, String],
    sitesSelected: [Array, String],
    countryList: { type: Array, default: () => [] },
    allSiteList: { type: Array, default: () => [] },
    participantsSelected: [Array, null],
    fromDate: { type: String },
    toDate: { type: String },
    selectedCountryIds: { type: Array, default: () => [] },
    selectedSiteIds: { type: Array, default: () => [] }
  },

  data() {
    return {
      viewDataBy: null,
      activeTab: "fitbit",
      countries: null,
      sites: null,
      upComingData: "Date",
      dateAndDayHeaders: [],
      tab: "",
      sensoresTabList: [],
      onFilterDate: false,
      rawData: null,
      tmpCountries: [],
      tmpSites: [],
      downloadId: "daily-sensor-compliance",
      width: "100%",
      height: "250px",
      zoomGraphValueChild: "",
      matrix: [],
      limit: 10,
      page: 1,
      activityLimit: 30,
      activityPage: 1,
      bufferPage: 0,
      horizontalScrollCount: 1,
      scroll: "first",
      isSensorConfigured: false,
      studyId: "",
      sensorComplianceObject: null
    };
  },
  computed: {
    ...mapGetters(["user", "studyIdValue", "sensorComplianceData"]),
    getSiteId() {
      return localStorage.getItem("selectedSite");
    },
    isSiteRole() {
      return commonHelper.isSiteUser(this.user.userRole);
    },
    checkCurrentSiteOrStudy() {
      return this.studyIdValue === this.studyId && (!this.isSiteRole || (this.isSiteRole && this.getSiteId === this.$store.state.selectedSiteId));
    }
  },
  methods: {
    sendCountryAndSiteData(countries, sites) {
      this.$emit("updateTmpCountries", countries);
      this.$emit("updateTmpSites", sites);
    },

    async getDailySensorCompliance() {
      this.isLoading = true;
      let response = null;
      const params = {
        studyId: this.$route.params.studyId
      };
      const body = {};

      if (this.fromDate && this.toDate) {
        body.fromDate = this.fromDate;
        body.toDate = this.toDate;
      }

      if (this.participantsSelected && this.participantsSelected[0] !== "all") {
        body.participantsIds = this.participantsSelected;
      }

      if (this.specificSiteId && this.specificSiteId.length > 0) {
        body.siteId = this.specificSiteId[0];
      }
      body.limit = this.limit;
      body.limitPage = this.page;
      body.activityLimit = this.activityLimit;
      body.activityPage = this.activityPage;
      body.activeTab = "fitbit";

      if (this.sensorComplianceData && this.sensorComplianceData.body && this.checkCurrentSiteOrStudy) {
        let result = this.sensorComplianceData.body;
        response = result.data;
      } else {
        const data = await this.$api.getSensorCompliance(params, body);

        if (data.ok) {
          let result = data.body;
          this.$store.dispatch("saveSensorComplianceData", data);
          this.$store.dispatch("saveStudyId", this.studyId);
          if (result.data !== {}) {
            response = result.data;
          }
        }
      }
      return response;
    },

    async getDailySensorComplianceCsv() {
      this.isLoading = true;
      let response = null;
      const params = {
        studyId: this.$route.params.studyId
      };
      const body = {};

      if (this.fromDate && this.toDate) {
        body.fromDate = this.fromDate;
        body.toDate = this.toDate;
      }

      if (this.participantsSelected && this.participantsSelected[0] !== "all") {
        body.participantsIds = this.participantsSelected;
      }

      if (this.selectedCountryIds && this.selectedCountryIds.length > 0 && this.selectedCountryIds[0] !== "all") {
        body.countryIds = this.selectedCountryIds;
      }

      if (this.selectedSiteIds && this.selectedSiteIds.length > 0 && this.selectedSiteIds[0] !== "all") {
        body.siteIds = this.selectedSiteIds;
      }

      if (this.specificSiteId && this.specificSiteId.length > 0) {
        if (body.siteIds && body.siteIds.length > 0) {
          body.siteIds.push(this.specificSiteId[0]);
        } else {
          body.siteIds = this.specificSiteId;
        }
      }

      body.activeTab = this.activeTab;
      body.downloadCsv = "true";
      //body.viewDataBy = this.viewDataBy;

      const data = await this.$api.getSensorCompliance(params, body);

      if (data.ok) {
        const result = data.body;

        if (result.data !== {}) {
          response = result.data;
        }
      }

      return response;
    },

    async callApi(filterBy) {
      let allApiCountries = this.tmpCountries;
      let apiPromises = [];
      if (["mounted", "date", "participant", "site", "country"].includes(filterBy)) {
        apiPromises = apiPromises.concat([
          this.getDailySensorCompliance().then(response => {
            // eslint-disable-next-line no-unused-vars
            const { IsSensorConfigured, StudyStartDate, StudyEndDate, ...responseData } = response;
            this.countries = utils.getCountriesByActivities(responseData);
            this.sites = utils.getSiteByActivities(responseData, this.countries);
            allApiCountries = allApiCountries.concat(this.countries);
            this.tmpCountries = this.tmpCountries.concat(this.countries);
            this.tmpSites = this.tmpSites.concat(this.sites);
            if (["mounted"].includes(filterBy)) {
              this.sendCountryAndSiteData(this.tmpCountries, this.tmpSites);
            }
            this.rawData = response;
          })
        ]);
      }

      await Promise.all(apiPromises);

      this.callApiCompleted = true;
    },

    onScrollTable(scrollDirection) {
      if (scrollDirection === "vertical") {
        this.page += 1;
        this.activityPage = 1;
        this.activityLimit = this.horizontalScrollCount * 30;
      } else if (scrollDirection === "horizontal") {
        this.bufferPage += 1;
        this.horizontalScrollCount += 1;
        if (this.activityPage !== 1) {
          this.activityPage += 1;
        } else {
          this.activityPage += this.bufferPage;
        }
        this.limit = this.page * this.limit;
        this.page = 1;
        this.activityLimit = 30;
      }
      this.getDailySensorCompliance().then(response => {
        this.rawData = response;
      });
      this.scroll = scrollDirection;
    },

    processVisualizationData(rawData) {
      let matrixData = null;
      if (!_.isEmpty(rawData)) {
        matrixData = studyCompliance.generateDailySensorMapData(rawData, this.countrySelected, this.sitesSelected, this.activeTab);
        this.isSensorConfigured = matrixData.IsSensorConfigured;
        this.sensoresTabList = matrixData.brandNames;

        if (this.scroll === "first") {
          this.dateAndDayHeaders = matrixData.listDate;
        } else {
          this.dateAndDayHeaders = _.unionBy(this.dateAndDayHeaders, matrixData.listDate, "date");
        }

        this.sensoresTabList.unshift("All Sensores");
        matrixData = matrixData.Data;
        this.$emit("newRawDataForSensor", this.isSensorConfigured);
      }
      if (this.scroll === "vertical") {
        if (!_.isEmpty(matrixData)) {
          const index = _.findIndex(this.matrix, {
            participantNames: matrixData[0].participantNames
          });
          if (index < 0) {
            const newMatrix = this.matrix.concat(matrixData);
            this.matrix = newMatrix;
          }
        }
      }
      if (this.scroll === "horizontal") {
        const newMatrix = this.matrix;
        this.matrix.map((row, index) => {
          const find = _.find(matrixData, {
            participantNames: row.participantNames
          });
          if (!_.isEmpty(find)) {
            const activity = find.matrixActivities;
            const newActivity = _.unionWith(newMatrix[index].matrixActivities, activity);
            newMatrix[index].matrixActivities = newActivity;
          }
        });
        this.matrix = newMatrix;
      }
      if (this.scroll === "first") {
        this.matrix = matrixData;
      }
    },

    statusOfDays(statusofday) {
      this.upComingData = statusofday;
    },

    handleDownloadCsv(title) {
      this.getDailySensorComplianceCsv().then(response => {
        const headerCsv = response.csvHeaders;
        const dataCsv = response.csvBody;
        downloadCSV(title, headerCsv, dataCsv, this.specificSiteId);
      });
    },

    zoomGraph(status) {
      if (status) {
        if (this.matrix.length === 10) {
          this.onScrollTable();
        }
        this.zoomGraphValueChild = true;
        this.height = "520px";
        this.$emit("zoomEnabled");
      } else {
        this.zoomGraphValueChild = false;
        this.height = "250px";
        this.$emit("zoomDisabled");
      }
    },
    filterRawData(filterBy){
      this.sensorComplianceObject = _.cloneDeep(this.rawData);
      let sensorData = this.sensorComplianceObject.fitbit;
      if(filterBy == "site" && this.sitesSelected[0] == "all"){
        this.processVisualizationData(this.sensorComplianceObject);
      }
      else if(filterBy == "country" && this.countrySelected[0] == "all"){
        this.processVisualizationData(this.sensorComplianceObject);
      }
      else if(filterBy == "site"){
        for (let countries in sensorData) {
          for (let sites in sensorData[countries]) {
            if(!this.sitesSelected.includes(sites)){
              delete sensorData[countries][sites];
            }
          }
        }
        this.sensorComplianceObject.fitbit = sensorData;
        this.processVisualizationData(this.sensorComplianceObject);
      }
      else if(filterBy == "country"){
        for (let countries in sensorData) {
          if(!this.countrySelected.includes(countries)){
            delete sensorData[countries];
          }
        }
        this.sensorComplianceObject.fitbit = sensorData;
        this.processVisualizationData(this.sensorComplianceObject);
      }
    }
  },

  watch: {
    rawData: function() {
      this.processVisualizationData(this.rawData);
    },

    countrySelected(newVal) {
      this.scroll = "first";
      if (newVal.length > 0) {
        const oldLimit = this.limit;
        this.limit = this.participantsSelected.length > 0 && this.participantsSelected[0] != "all" ? this.limit : 1000;
        this.activityLimit = this.activityPage * this.activityLimit;
        this.activityPage = 1;
        this.page = 1;
        this.filterRawData("country");
        this.limit = oldLimit;
      } else {
        this.processVisualizationData(this.rawData);
      }
    },

    sitesSelected(newVal) {
      this.scroll = "first";
      if (newVal.length > 0) {
        const oldLimit = this.limit;
        this.limit = this.participantsSelected.length > 0 && this.participantsSelected[0] != "all" ? this.limit : 1000;
        this.activityLimit = this.activityPage * this.activityLimit;
        this.activityPage = 1;
        this.page = 1;
        this.filterRawData("site");
        this.limit = oldLimit;
      } else {
        this.processVisualizationData(this.rawData);
      }
    },

    zoomGraphValue: function(newVal) {
      this.zoomGraphValueChild = newVal;
      if (newVal == "") {
        this.height = "250px";
      }
    },

    participantsSelected(newVal) {
      this.scroll = "first";
      if (newVal.length > 0) {
        const oldLimit = this.limit;
        this.limit = newVal.length > 0 && newVal[0] != "all" ? this.limit : 1000;
        this.activityLimit = this.activityPage * this.activityLimit;
        this.activityPage = 1;
        this.page = 1;
        this.callApi("participant");
        this.limit = oldLimit;
      } else {
        this.rawData = null;
      }
    },

    fromDate() {
      this.scroll = "first";
      const oldLimit = this.limit;
      this.limit = this.participantsSelected.length > 0 && this.participantsSelected[0] != "all" ? this.limit : 1000;
      this.activityLimit = this.activityPage * this.activityLimit;
      this.activityPage = 1;
      this.page = 1;
      this.callApi("date");
      this.limit = oldLimit;
    },

    toDate() {
      this.scroll = "first";
      const oldLimit = this.limit;
      this.limit = this.participantsSelected.length > 0 && this.participantsSelected[0] != "all" ? this.limit : 1000;
      this.activityLimit = this.activityPage * this.activityLimit;
      this.activityPage = 1;
      this.page = 1;
      this.callApi("date");
      this.limit = oldLimit;
    },

    siteListInParticipants() {
      this.scroll = "first";
      this.processVisualizationData(this.rawData);
    },

    specificSiteId(newVal) {
      this.specificSiteId = newVal;
      this.scroll = "first";
      if(this.isSiteRole){
        this.callApi("mounted");
      }
    }
  },

  mounted() {
    this.studyId = this.$route.params.studyId;
    if(!this.isSiteRole){
      this.callApi("mounted");
    }
  }
};
</script>

<style scoped lang="scss">
.info-custom-tooltip {
  position: relative;
  display: inline-block;
  z-index: 1000;

  .fa.fa-info-circle {
    font-size: 16px !important;

    &::before {
      color: #aaaaaa !important;
    }
  }

  .info-custom-tooltiptext {
    font-size: 10px !important;
    font-family: "RobotoRegular";
    visibility: hidden;
    width: 310px;
    white-space: break-spaces;
    background-color: #eff3f5;
    color: #666669;
    text-align: left;
    border-radius: 5px;
    padding: 10px 12px 11px 12px;
    font-weight: 500;
    position: absolute;
    z-index: 1000;
    top: -8px;
    left: 110%;
    margin-left: 8px;
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.25);
    text-overflow: unset !important;
    white-space: normal !important;
    border: solid 1px #b0bac9;

    &::before {
      content: " ";
      position: absolute;
      top: 5.2%;
      right: 100%;
      height: 10px;
      margin-top: -4px;
      border-width: 10.5px;
      border-style: solid;
      border-color: transparent #b0bac9 transparent transparent;
    }

    &::after {
      content: " ";
      position: absolute;
      top: 6%;
      right: 100%;
      height: 10px;
      margin-top: -5px;
      border-width: 9px;
      border-style: solid;
      border-color: transparent #eff3f5 transparent transparent;
    }
  }

  &:hover .info-custom-tooltiptext {
    visibility: visible;
  }
}
</style>
